import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "paginator-wrapper" }
const _hoisted_2 = { class: "paginator" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 2 }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "page-size" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Pagination Buttons "),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Previous "),
      _createElementVNode("button", {
        disabled: $props.currentPage === 1,
        onClick: _cache[0] || (_cache[0] = $event => ($setup.changePage($props.currentPage - 1)))
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("i", { class: "fa-solid fa-arrow-left" }, null, -1 /* CACHED */)
      ]), 8 /* PROPS */, _hoisted_3),
      _createCommentVNode(" First page "),
      ($setup.startPage > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = $event => ($setup.changePage(1)))
          }, " 1 "))
        : _createCommentVNode("v-if", true),
      ($setup.startPage > 2)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "..."))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Page numbers "),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.visiblePages, (page) => {
        return (_openBlock(), _createElementBlock("button", {
          key: page,
          class: _normalizeClass({ active: page === $props.currentPage }),
          onClick: $event => ($setup.changePage(page))
        }, _toDisplayString(page), 11 /* TEXT, CLASS, PROPS */, _hoisted_5))
      }), 128 /* KEYED_FRAGMENT */)),
      ($setup.endPage < $setup.totalPages - 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "..."))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Last page "),
      ($setup.endPage < $setup.totalPages)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            onClick: _cache[2] || (_cache[2] = $event => ($setup.changePage($setup.totalPages)))
          }, _toDisplayString($setup.totalPages), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Next "),
      _createElementVNode("button", {
        disabled: $props.currentPage === $setup.totalPages,
        onClick: _cache[3] || (_cache[3] = $event => ($setup.changePage($props.currentPage + 1)))
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("i", { class: "fa-solid fa-arrow-right" }, null, -1 /* CACHED */)
      ]), 8 /* PROPS */, _hoisted_7)
    ]),
    _createCommentVNode(" Page Size Selector "),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", null, [
        _cache[6] || (_cache[6] = _createTextVNode(" Per page: ")),
        _createElementVNode("select", {
          value: $props.pageSize,
          onChange: $setup.onPageSizeChange
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pageSizeOptions, (size) => {
            return (_openBlock(), _createElementBlock("option", {
              key: size,
              value: size
            }, _toDisplayString(size), 9 /* TEXT, PROPS */, _hoisted_10))
          }), 128 /* KEYED_FRAGMENT */))
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_9)
      ])
    ])
  ]))
}